<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Active users</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/locked/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        <span>Locked users</span>
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/deleted/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-user-times" aria-hidden="true"></i>
                        <span>Deleted users</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <a :href="`/#/admin/organizations/users/create/${tid}`" role="button" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                        <i class="fa fa-user-plus" aria-hidden="true"></i>
                        <span>Add user</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <UsersTable v-if="users.length" :users="users"></UsersTable>
            <h4 v-else>No active users</h4>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@Organizations/Users/Components/UsersTable.vue";

    @Component
    export default class ActiveUsersPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        mounted() {
            this.setTitle("Active users");
            this.runSearchAllUsersQueryV1(this.tid, '', true, false, false);
        }

        get allUsersSearchResult() { return this.model?.AllUsersSearchResult; }
        get users() { return this.allUsersSearchResult?.Users || []; }
    }
</script>

<style scoped>
</style>